/* -----------------------------------------------------------------------------
 * Aura Prime
 * -------------------------------------------------------------------------- */
(function($) {
	'use strict'

	document.addEventListener('DOMContentLoaded', () => {
		siteScolled()
		stickyHeader()
		menuHashLinkFix()
		stickyElements()
		collapsibleNavMenuWidget()
	})

	/* ---------------------------------------------------------------------------
	 * Variables.
	 * ------------------------------------------------------------------------ */
	let l10n = {
		collapsibleNavMenuWidget: {
			open: 'Open Sub Menu',
			close: 'Close Sub Menu'
		}
	}

	if ('object' === typeof auraPrimeAppL10n) {
		l10n = { ...auraPrimeAppL10n, ...l10n }
	}

	const bodyEl = document.querySelector('body')

	/* ---------------------------------------------------------------------------
	 * Check if the site is scrolled.
	 * ------------------------------------------------------------------------ */
	const siteScolled = () => {
		let offset = 0

		if (bodyEl.classList.contains('admin-bar')) {
			offset += document.querySelector('#wpadminbar').clientHeight
		}

		window.addEventListener('scroll', () => {
			const dataAttribute = 'data-aura-site-scolled'

			if (window.scrollY > offset) {
				bodyEl.setAttribute(dataAttribute, '')
			} else {
				bodyEl.removeAttribute(dataAttribute)
			}
		})
	}

	/* ---------------------------------------------------------------------------
	 * Sticky header.
	 * ------------------------------------------------------------------------ */
	const stickyHeader = () => {
		const headerEl = document.querySelector('.aura-header')
		let offset = 0

		if (headerEl) {
			offset += headerEl.clientHeight
		}

		if (bodyEl.classList.contains('admin-bar')) {
			offset += document.querySelector('#wpadminbar').clientHeight
		}

		const dataAttribute = 'data-aura-sticky-header'
		let oldScrollPosition = window.scrollY

		window.addEventListener('scroll', () => {
			const newScrollPosition = window.scrollY
			let scrollDirection = 'down'

			if (newScrollPosition < oldScrollPosition) {
				scrollDirection = 'up'
			}

			if (newScrollPosition > offset && scrollDirection === 'up') {
				bodyEl.setAttribute(dataAttribute, 'true')
			} else {
				bodyEl.setAttribute(dataAttribute, 'false')
			}

			oldScrollPosition = newScrollPosition
		})
	}

	/* ---------------------------------------------------------------------------
	 * Fix hash links in menus
	 * ------------------------------------------------------------------------ */
	const menuHashLinkFix = () => {
		$('.aura-menu a[href="#"]').on('click', function(e) {
			e.preventDefault()
		})
	}

	/* ---------------------------------------------------------------------------
	 * Sticky Elements
	 * ------------------------------------------------------------------------ */
	const stickyElements = () => {
		let offset = 25

		offset += $('.aura-sticky-header').outerHeight()

		if ($('body').hasClass('admin-bar')) {
			offset += $('#wpadminbar').outerHeight()
		}

		$('[data-aura-sticky-element]').theiaStickySidebar({
			additionalMarginTop: wp.hooks.applyFilters(
				'aura/stickyElements/marginTop',
				offset
			),
			additionalMarginBottom: 30,
			minWidth: 1024
		})
	}

	/* ---------------------------------------------------------------------------
	 * Collapsible Navigation Menu Widget.
	 * ------------------------------------------------------------------------ */
	const collapsibleNavMenuWidget = () => {
		const buttonClass = 'aura-nav-menu-widget__submenu-button'
		const dataAttribute = 'data-aura-submenu'

		$('.aura-nav-menu-widget .menu-item-has-children').each(function() {
			// Add sub menu button.
			$(this).append(
				`<div class="${buttonClass}"><span>${
					l10n.collapsibleNavMenuWidget.open
				}</span></div>`
			)

			// Activate expandOnClickNavigation() on menu buttons.
			$(`> .${buttonClass}`, this).on('click', function(e) {
				e.preventDefault()
				$(this).expandOnClickNavigation()
			})

			// Activate expandOnClickNavigation() on the parents with # href attribute.
			$('> a', this).on('click', function(e) {
				if ('#' === $(this).attr('href')) {
					e.preventDefault()
					$(this).expandOnClickNavigation()
				}
			})

			$.fn.expandOnClickNavigation = function() {
				const menuEl = $(this).parent()
				const buttonEl = menuEl.children(`.${buttonClass} span`)
				const subMenuEl = menuEl.children('.sub-menu')
				const allSubMenuEl = menuEl.find('.sub-menu')
				const childrenMenuEl = menuEl.find('.menu-item-has-children')

				if ('expanded' === menuEl.attr(dataAttribute)) {
					// Change status to collapsed.
					menuEl.attr(dataAttribute, 'collapsed')
					// slideUp all sub menus.
					allSubMenuEl.slideUp(250)
					// Change status of all children to collapsed.
					childrenMenuEl.attr(dataAttribute, 'collapsed')
					// Change button text.
					buttonEl.text(l10n.collapsibleNavMenuWidget.open)
				} else {
					// Change status to expanded.
					menuEl.attr(dataAttribute, 'expanded')
					// slideUp sub-menu that is a direct child.
					subMenuEl.slideDown(250)
					// Change button text.
					buttonEl.text(l10n.collapsibleNavMenuWidget.close)
				}
			}
		})
	}
})(jQuery)
